<template>
	<div>

		<!--<el-row class="transfer">-->
		<!--<page-title>{{msg}}</page-title>-->
		<div class="buy-box">
			<el-form ref="form" :model="form" label-width="200px">
				<el-form-item label="订单号:">
					<!--<el-input v-model="form.name"></el-input>-->
					<span> {{id}}</span>
				</el-form-item>
				<!--<el-form-item label="注册购买年数:">
					<el-select v-model="form.priced" placeholder="请选择活动区域" value-key="ha">
						<el-option v-for="item in form.price" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select><span style="margin-left: 5px;">年</span>
				</el-form-item>-->
				<el-form-item label="支付方式:">
					<el-button v-for="(item,i) in payment " :key="i" size="mini" :disabled="item.lock" @click="paymentNow = i">
						<span style="position: relative;display: inline-block;">
			<i class="el-icon-success" style="position: absolute; right: -18px;top: -16px;font-size: 20px;color: #1b59a8;" v-show="paymentNow===i"></i>
				<img :src="item.icon" style="width: 80px;" />
				</span>

					</el-button>
				</el-form-item>
				<el-form-item label="支付费用:">

					<!--<el-input v-model="form.name"></el-input>-->
					<span>{{form.priced||0}}元</span>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" @click="buy">立即支付</el-button>
					<el-button @click="$router.go(-1)">取消</el-button>
				</el-form-item>
			</el-form>
		</div>

		<!--</el-row>-->
	</div>
</template>

<script>
	//import PageTitle from '@/components/PageTitle'
	export default {
		data() {
			return {
				year: '',
				form: {

					unitprice: '',
					price: [{
						value: '',
						label: ''
					}],
					priced: ''
				},
				htmls: '',
				outTradeNo: '',
				formHtml: '',
				state: '',
				paymentNow: 0,
				payment: [{
						icon: require('@/assets/imgs/z.png'),
						lock: false
					},
					{
						icon: require('@/assets/imgs/w.png'),
						lock: true
					},
					{
						icon: require('@/assets/imgs/y.png'),
						lock: true
					},
				]
			}
		},
		created() {

			//			this.$http.get(this.$api + '/identificationApply/getIdentificationOrderByOrderNo', {
			//				params: {
			//					paymentOrder: this.id
			//				}
			//			}).then(res => {
			////				console.log(res.body.entity.account)
			//				if(res.body.result === 1) {
			//
			//					this.form.priced = res.body.entity.account;
			//
			//				}
			//
			//			})
			//			/identificationApply/getIdentificationOrderByOrderNo
			this.$http.get(this.$api + '/identificationApply/getIdentificationOrderByOrderNo', {
				params: {
					paymentOrder: this.id
				}
			}).then(res => {
				//					console.log(res)
				this.state = res.body.result;
				if(res.body.result === 1) {
					//						注册成功，支付宝支付！
					let {
						//							aliPayHtml,
						account
					} = res.body.entity;

					this.outTradeNo = this.id;
					//						 this.formHtml=aliPayHtml.replace(/\n+/g,'')
					this.form.priced = account;
					//	document.querySelector('body').innerHTML = aliPayHtml;
					//						let routerData = this.$router.resolve({
					//							path: '/applyText',
					//							query: {
					//								html: aliPayHtml
					//							}
					//						})
					//						this.htmls = res.data.result
					//						const newhref = routerData.href + '?html=' + aliPayHtml
					//						tempPage.location = newhref
					//console.log( this.id)
					//						this.$alert('请您及时在线支付以进入审核流程，支付成功后点击确认', '支付', {
					//							confirmButtonText: '确定',
					//							callback: action => {
					//								this.$http.post(this.$api + '/identificationApply/identificationPayQuery', {
					//									outTradeNo: this.id,
					//
					//								}).then(res => {
					//									console.log(res.body)
					//									if(res.body.result === 1) {
					//										this.$message({
					//											message: '支付成功',
					//											type: 'success'
					//										});
					//									} else {
					//										this.$message.error(res.body.message);
					//
					//									}
					//								})
					//							}
					//						});

				} else {
					//						this.$message.error(res.body.message);
					//                          this.$route.go()

				}
			})
		},
		props: {
			name: String,
			type: Number,
			id: String,

		},
		methods: {
			buy() {
				let tempPage = window.open("", '_blank');
				this.$http.post(this.$api + '/identificationApply/finishIdentificationOrderByOrderNo', {
					paymentOrder: this.id,
					returnUrl: window.location.protocol + "//" + window.location.host + '/unitIndex/succeed',
				}).then(res => {
					//					console.log(res)
					if(res.body.result === 1) {
						//						注册成功，支付宝支付！
						//						let {
						//							formHtml,
						//
						//						} = this;
						let {
							aliPayHtml,
							//                              account
						} = res.body.entity;

						//						this.outTradeNo = this.id;
						this.formHtml = aliPayHtml.replace(/\n+/g, '')

						//                      this.form.priced =account;
						//						this.outTradeNo = this.id;

						//						document.querySelector('body').innerHTML = aliPayHtml;
						let routerData = this.$router.resolve({
							path: '/applyText',
							query: {
								html: this.formHtml
							}
						})
						//						this.htmls = res.data.result				
						const newhref = routerData.href + '?html=' + this.formHtml;
						document.forms[0].acceptCharset = 'UTF-8';
						tempPage.location = newhref
						//						document.forms[0].submit();
						//console.log( this.id)
						this.$alert('请您及时在线支付以进入审核流程，支付成功后点击确认', '支付', {
							confirmButtonText: '确定',
							callback: action => {
								this.$http.post(this.$api + '/identificationApply/identificationPayQuery', {
									outTradeNo: this.id,

								}).then(res => {
									//									console.log(res.body)
									if(res.body.result === 1) {
										//										this.$message({
										//											message: '支付成功',
										//											type: 'success'
										//										});
										this.$router.go(-1)
									} else {
										this.$message.error({
											message: res.body.message,
											duration: '900'
										});
										setTimeout(() => {
											this.$router.go(-1)
										}, 1000)

									}
								})
							}
						});

					} else if(res.body.result === 2) {
						tempPage.close();
						this.$message({
							message: '恭喜你，注册成功',
							type: 'success',
							duration: '900',

						});
						setTimeout(() => {
							this.$router.push('enterprisemb')

						}, 1000)

					} else {

						tempPage.close();
						this.$message.error(res.body.message);
						//						延时跳转
						//						this.$message.error('异常错误，请尝试刷新或点击取消返回重新操作');
					}
				})
			},
			price() {
				this.$http.get(this.$api + '/identificationApply/getSalePrice', {
					//					params: {
					//						domain: 'https://www.idcode1.org.cn'
					//					}
				}).then(res => {
					//					console.log(this.form.price)
					this.form.price = res.body.entity.map((item, index) => {
						return {
							value: item.price + item.unit + '|' + item.year,
							label: item.year,

						}
					})

					this.form.priced = this.form.price[0].value;
				})
				//			console.log(this.form.price[0].value)

			},
			source(val) {
				//				console.log(val)
				this.year = val
			}
		},
		components: {
			//      PageTitle
		}

	}
</script>

<style lang="scss">
	.xufei {
		width: 100%;
		border: solid red 1px;
		/*text-align: left;*/
		/*padding: 50px 0 0 300px;*/
		li {
			width: 100%;
			height: 50px;
			p {
				width: 100%;
				line-height: 50px;
				.bt {
					display: inline-block;
					text-align: right;
					width: 100px;
				}
			}
		}
	}
	
	.buy-box {
		text-align: left;
		padding: 50px 0 0 0px;
		/*border: solid red 1px;*/
		width: 600px;
	}
</style>